<template>
    <div>
        <ui-modal  
            ref="editModal" 
            class="invoice-payments-modal"
            title="Edit Invoice Payments" 
            size="large" 
            @hide="hidden"
            dismiss-on="close-button esc"
        >
            <invoice-payments  
                v-if="payments"
                v-model="payments"
                :invoice="invoice"
                :disabled="disabled"
                @cancel="cancel"
            />
            <div>
                <hr style="border-top-width: 3px;">
                <span :class="outstandingTextClasses">Total Outstanding: {{ totalOutstanding | currency(2) }}</span>
            </div>
            <div 
                slot="footer" 
                style="width: 100%; text-align: right;"
            >
                <ui-button 
                    type="primary" 
                    @click="close"
                >
                    Cancel
                </ui-button>
                <ui-button 
                    color="primary" 
                    @click="done"
                >
                    Done
                </ui-button>
            </div>
        </ui-modal>
        
        <invoice-cancellation-modal ref="cancellationModal" />
    </div>
</template>

<style lang="scss">
    .invoice-payments-modal.ui-modal--size-large > .ui-modal__wrapper > .ui-modal__container { width: 60rem; }

    .outstanding-text {
        font-size: 1.5rem;
        margin-top: 1rem;
        margin-bottom: 1rem;
        display: block;
        color: green;
        font-weight: 500;
        text-align: right;

        &.outstanding {  color: orange; }
    }
</style>

<script>
    import Filters from '../../filters'
    import { InvoiceHelper } from '../../classes/Api/Invoice'
    import InvoiceCancellationModal from './InvoiceCancellationModal'

    export default {
        components: { InvoiceCancellationModal },
        filters: Filters,
        props: {
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                invoice: null
            }
        },
        computed: {
            payments: {
                get() {
                    return this.invoice ? this.invoice.payments : []
                },
                set(value) {
                    if (this.invoice) {
                        this.invoice.payments = value
                    }
                }
            },
            totalPayments() {
                if (this.invoice) {
                    let helper = new InvoiceHelper(this.invoice);
                    let paid = 0

                    for (let payment of this.payments) {
                        paid += parseFloat(payment.amount) || 0
                    }

                    return helper.total() - paid
                }

                return 0
            },
            totalOutstanding() {
                if (this.invoice) {
                    let helper = new InvoiceHelper(this.invoice);
                    let paid = 0

                    for (let payment of this.payments) {
                        if (payment.is_posted || payment.is_approved) {
                            paid += parseFloat(payment.amount) || 0
                        }
                    }

                    return helper.total() - paid
                }

                return 0
            },
            outstandingTextClasses() {
                if (0 !== this.totalOutstanding) {
                    return 'outstanding-text outstanding'
                }

                return 'outstanding-text'
            }
        },
        methods: {
            open(invoice) {
                this.invoice = _.cloneDeep(invoice)

                this.$refs.editModal.open();
            },
            cancel() {
                this.close();
                this.$emit('cancel')
            },
            done() {
                let invoice = _.cloneDeep(this.invoice);
                this.$emit('updated', invoice.payments)
                this.close();
            },
            close() {
                this.$refs.editModal.close()
            },
            hidden() {
                this.invoice = null
            }
        }
    }
</script>